var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOneLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8752 14.8369L0.0197144 14.088C0.338888 8.00224 4.95975 3.30057 11.0384 2.875L11.8752 14.8369Z",
    fill: "#5BB130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6016 15.1631L10.6011 0.863696C10.5931 0.755359 10.6073 0.64654 10.6427 0.54384C10.6781 0.44114 10.734 0.3467 10.807 0.266249C10.88 0.185798 10.9685 0.121012 11.0673 0.075822C11.1661 0.0306318 11.273 0.00597909 11.3816 0.00335921C15.3846 -0.0774572 18.96 1.30051 21.9369 4.0759L11.6016 15.1631Z",
    fill: "#16A638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1043 14.3927L22.8724 2.8462C22.9468 2.76629 23.0367 2.70233 23.1367 2.65819C23.2366 2.61405 23.3444 2.59065 23.4536 2.58941C23.5629 2.58816 23.6712 2.6091 23.7721 2.65096C23.873 2.69281 23.9643 2.75471 24.0406 2.8329C27.1157 5.96019 28.7842 9.79744 28.9745 14.1799C28.9799 14.2895 28.963 14.399 28.9247 14.5018C28.8863 14.6046 28.8275 14.6985 28.7516 14.7778C28.6758 14.857 28.5846 14.92 28.4836 14.9629C28.3827 15.0057 28.274 15.0275 28.1643 15.027H12.3785C12.3053 15.0265 12.2337 15.0047 12.1727 14.9643C12.1116 14.9238 12.0636 14.8665 12.0345 14.7993C12.0055 14.7321 11.9966 14.6578 12.009 14.5856C12.0214 14.5134 12.0545 14.4464 12.1043 14.3927Z",
    fill: "#6DB64A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5131 15.0273H25.5639C25.5639 18.7521 24.3291 21.8814 21.789 24.6097L11.5131 15.0273Z",
    fill: "#4BAD33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5131 15.0273L22.5143 25.2859C22.5937 25.3595 22.6575 25.4483 22.7017 25.5471C22.746 25.6459 22.7698 25.7526 22.7718 25.8609C22.7738 25.9691 22.754 26.0766 22.7134 26.177C22.6728 26.2774 22.6124 26.3685 22.5358 26.445C21.5538 27.4244 20.4328 28.2537 19.209 28.9063C19.1134 28.9571 19.0085 28.9881 18.9007 28.9974C18.7928 29.0067 18.6842 28.9941 18.5813 28.9603C18.4784 28.9266 18.3834 28.8725 18.3019 28.8011C18.2205 28.7298 18.1543 28.6427 18.1073 28.5452L11.5131 15.0273Z",
    fill: "#6DB64A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0982 16.2231L16.982 26.2372C14.4156 27.4815 11.4706 27.6968 8.75052 26.8392C6.03049 25.9815 3.74161 24.1158 2.35315 21.6245L12.0982 16.2231Z",
    fill: "#16A638"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.5225 26.4467L11.5016 15.8526L11.9589 15.6367L15.3911 22.9419L16.9818 26.2359L16.5225 26.4467Z",
    fill: "#08672F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5556 15.5337H14.496V15.0273H25.5637L25.5556 15.5337Z",
    fill: "#08672F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.0537 26.6393L11.041 16.0636L11.4983 15.8467L16.5222 26.4469L16.0537 26.6393Z",
    fill: "#08672F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.8181 3.97686L14.249 12.1056L13.8776 11.7618L21.4314 3.62598L21.8181 3.97686Z",
    fill: "#08672F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.4296 3.62663L13.9055 11.742L13.5341 11.3983L21.0419 3.30029L21.4296 3.62663Z",
    fill: "#08672F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.7438 2.89941L11.5049 13.9365L11.0006 13.9713L10.2497 2.95568L10.7438 2.89941Z",
    fill: "#08672F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.2494 2.95557L11.0074 14.0131L10.5021 14.0479L9.7522 3.03229L10.2494 2.95557Z",
    fill: "#08672F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.532 16.0401H14.496V15.5337H25.5556L25.532 16.0401Z",
    fill: "#08672F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.1386 24.2213L13.5291 16.2409L13.8738 15.8706L22.4659 23.8367L22.1386 24.2213Z",
    fill: "#08672F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.1806 16.8442L22.1385 24.2221L21.7886 24.6098L13.8369 17.2156L14.1806 16.8442Z",
    fill: "#08672F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18457 22.9093L3.66538 6.06779L4.21984 5.57471H17.1362C17.6476 5.57471 18.0681 5.87342 18.0681 6.23965V23.2152C18.0681 23.5845 17.6507 23.8801 17.1362 23.8801H4.00501L3.62548 23.4577L3.18457 22.9093Z",
    fill: "#08672F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70522 6.11279H16.4926C17.0154 6.11279 17.441 6.39821 17.441 6.75421V22.7958C17.441 23.1487 17.0154 23.4362 16.4926 23.4362L3.63055 23.4576L3.18964 22.9093L3.62339 6.89743",
    fill: "#08672F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1244 6.11279H0.672107C0.300912 6.11279 0 6.41371 0 6.7849V22.2372C0 22.6084 0.300912 22.9093 0.672107 22.9093H16.1244C16.4956 22.9093 16.7965 22.6084 16.7965 22.2372V6.7849C16.7965 6.41371 16.4956 6.11279 16.1244 6.11279Z",
    fill: "#08672F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4826 12.5718C6.16752 13.1743 5.97111 13.6848 5.97111 14.8561C5.97111 16.9972 6.90305 18.3537 8.34138 18.3537C9.79608 18.3537 10.7106 16.9972 10.7106 14.8561C10.7106 12.7314 9.78994 11.4802 8.34138 11.4567C7.76339 11.4495 7.18029 11.7974 7.18029 11.7974L6.56649 9.67465C7.13644 9.47526 7.73657 9.37593 8.34036 9.38105C11.217 9.38105 13.1781 11.3912 13.1781 14.8561C13.1781 18.3343 11.217 20.4294 8.34036 20.4294C5.47598 20.4294 3.50262 18.3374 3.50262 14.8561C3.50262 13.6111 3.75633 12.5574 4.21258 11.7155L6.4826 12.5718Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61125 8.5708L6.35701 11.0434C6.1071 11.1505 5.89984 11.3376 5.76776 11.5753L3.25836 10.6117C3.76959 9.66886 4.60565 8.94366 5.61125 8.5708Z",
    fill: "#EAAB1B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLens);
export default __webpack_public_path__ + "static/media/OneLens.affe9cd5616cc96f070981622f3d2548.svg";
export { ForwardRef as ReactComponent };